module.exports = __webpack_public_path__ + "img/fpss.13c64b7d.png";